module.exports = __webpack_public_path__ + "static/media/light-black-flag.b889e9d3.svg";